<template>
  <div>
    <!-- Chinese NavBar -->
    <nav class="navbar navbar-expand-lg navbar-light fixed-top" id="main-nav" v-if="require('../router/routerSetting').getLanguage() === 'tw'">
      <a class="navbar-brand" href="/" id="logo"><img src="@/assets/images/logo.svg" alt="Yulon Finance" class="mb-2" style="height:38px"></a>
      <!-- <a class="navbar-brand" href="/" id="logo" v-if="require('../router/routerSetting').getLanguage() === 'tw'"><img src="@/assets/images/logo.svg" alt="Yulon Finance" class="mb-2" style="height:38px"></a> -->
      <!-- <a class="navbar-brand" href="/En" id="logo" v-else><img src="@/assets/images/en/logo_en.svg" alt="Yulon Finance" class="mb-2" style="height:38px"></a> -->
      <!-- <button class="navbar-toggler p-0 border-0" type="button" data-toggle="offcanvas">
        <span class="navbar-toggler-icon"></span>
      </button> -->
      <button class="navbar-toggler collapsed" type="button" data-toggle="offcanvas" >
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>

      <div class="navbar-collapse offcanvas-collapse">
        <ul class="navbar-nav ml-auto px-xl-5 px-lg-4">
          <!-- <li class="nav-item p-3 dropdown dmenu" v-for="item in nav" :key="item.title"> -->
          <li class="nav-item dropdown dmenu" v-for="(item, key) in changRouter(paratmers)" :key="key" @mouseover.capture="hoverNav($event)" @mouseleave="removeNav($event)">
            <a v-if="item.internalUrl !== undefined" class="nav-link p-3" :href="item.internalUrl" :id="key">{{ item.name }}</a>
            <a v-else-if="item.hasPage !== undefined" class="nav-link p-3" :href="item.path" :id="key">{{ item.name }}</a>
            <a v-else-if="item.children !== undefined" class="nav-link p-3" href="#" :id="key">{{ item.name }}</a>
            <a v-else class="nav-link p-3" :href="item.path" :id="key">{{ item.name }}</a>
            <div class="dropdown-menu sm-menu" :aria-labelledby="key">
              <div class="d-flex" v-html="menu(item, windowsType)">
              </div>
              <!-- <a class="dropdown-item" :href="item.url[key]" v-for="(subItem, key) in item.subTitle" :key="key">{{ subItem }}</a> -->
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <!-- English NavBar -->
    <nav class="navbar navbar-expand-lg navbar-light fixed-top nav-en" id="main-nav" v-else>
      <a class="navbar-brand" href="/En" id="logo"><img src="@/assets/images/en/logo_en.svg" alt="Yulon Finance" class="mb-2" style="height:38px"></a>
      <button class="navbar-toggler p-0 border-0" type="button" data-toggle="offcanvas">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse offcanvas-collapse">
        <ul class="navbar-nav ml-auto px-xl-5 px-lg-4">
          <!-- <li class="nav-item p-3 dropdown dmenu" v-for="item in nav" :key="item.title"> -->
          <li class="nav-item dropdown dmenu" v-for="(item, key) in changRouter(paratmers)" :key="key" @mouseover.capture="hoverNav($event)" @mouseleave="removeNav($event)">
            <a v-if="item.internalUrl !== undefined" class="nav-link p-3" :href="item.internalUrl" :id="key">{{ item.name }}</a>
            <a v-else-if="item.hasPage !== undefined" class="nav-link p-3" :href="item.path" :id="key">{{ item.name }}</a>
            <a v-else-if="item.children !== undefined" class="nav-link p-3" href="#" :id="key">{{ item.name }}</a>
            <a v-else class="nav-link p-3" :href="item.path" :id="key">{{ item.name }}</a>
            <div class="dropdown-menu sm-menu" :aria-labelledby="key">
              <div class="d-flex" v-html="menu(item, windowsType)">
              </div>
              <!-- <a class="dropdown-item" :href="item.url[key]" v-for="(subItem, key) in item.subTitle" :key="key">{{ subItem }}</a> -->
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
import $ from 'jquery'  
$(function () {
  $('[data-toggle="offcanvas"]').on('click', function () {
      $('.offcanvas-collapse').toggleClass('open')
      $('.navbar-toggler').toggleClass('collapsed')
  })
})

export default {
  // props: ['paratmers'],
  name: 'headerMenu',
  data () {    
    return {      
      paratmers: window.location.pathname.indexOf('En') > -1 ? 'En' : 'Tw',
      windowsType: window.innerWidth > 991 ? 'web' : 'mobile',
      // routers: this.$router.options.routes.filter(o => o.path.indexOf('Tw') > 0)
      // windowWidth: window.innerwidth,
    }
  },
  methods: {
    changRouter: function (obj) {        
      this.$emit('valueToParent', this.paratmers)      
      return this.$router.options.routes.filter(o => o.path.indexOf(obj) > 0 && o.showClass !== 'headerlink')
    },
    menu: function (obj, type) {      
      var strmenu = ''
      if (obj.children !== undefined) {        
        obj.children.forEach((p, i) => {
          if (p.children !== undefined && type === 'web') {
            strmenu += '<div key="' + p.name + '" style="width:100%">'
            // 判斷第二層是否有Page            
            if(p.hasPage !== undefined){
              
              strmenu += '<a class="dropdown-item" href="'+ obj.path + '/' + p.path + '">' + p.name + '</a>'
            }
            else{
              strmenu += '<a class="dropdown-item second-title" href="#">' + p.name + '</a>'
            }
             
            p.children.forEach(l => {
              if(l.internalUrl === undefined){
                strmenu += '<a class="dropdown-item" href="' + obj.path + '/' + p.path + '/' + l.path + '" key="' + l.name + '">' + l.name + '</a>'
              }
              else{
                strmenu += '<a class="dropdown-item" href="' + l.internalUrl + '" target="_blank" key="' + l.name + '">' + l.name + '</a>'
              }
              
            })
            strmenu += '</div>'
          } else {              
            var subPath = p.children !== undefined ? '/' + p.children[0].path : '';

            if (i === 0) {
              strmenu += '<div key="' + p.name + '" style="width:100%">' +
                      '<a class="dropdown-item" href="' + obj.path + '/' + p.path + subPath + '">' + p.name + '</a>'
            } else if (obj.children.length === i + 1) {
              strmenu += '<a class="dropdown-item" href="' + obj.path + '/' + p.path + subPath + '">' + p.name + '</a></div>'
            } else {
              strmenu += '<a class="dropdown-item" href="' + obj.path + '/' + p.path + subPath + '">' + p.name + '</a>'
            }
          }
        })
        return strmenu
      }
    },
    hoverNav: function(obj){
      // $(obj.currentTarget).find('.sm-menu').first().stop(true, true).slideDown(200)
      $(obj.currentTarget).find('.sm-menu').first().stop(true, true).slideDown(0)
    },
    removeNav: function(obj){
      // $(obj.currentTarget).find('.sm-menu').first().stop(true, true).slideUp(150)
      $(obj.currentTarget).find('.sm-menu').first().stop(true, true).slideUp(0)
    },
    screenWidth:function(val){ //監聽螢幕寬度變化
        this.windowsType = val > 991 ? 'web' : 'mobile';
        
        if( val < 991 && !$('#main-nav').hasClass("nav-en") ){
          $(window).scroll(function() {
            if ( $(this).scrollTop() > 100){
              $('.nav-blue').removeClass('fixed-top');
              $('#main-nav').addClass('nav-logo');              
              $('.offcanvas-collapse').addClass('offcanvas-height');
              
            } else {
              $('.nav-blue').addClass('fixed-top');
              $('#main-nav').removeClass('nav-logo');
              $('.offcanvas-collapse').removeClass('offcanvas-height');
            }
          });
        }
    },    
  },
  //綁定DOM之後
  mounted() {
    this.screenWidth(window.innerWidth);
    var _this = this; //這裡寫的this為vue，若寫在function()內this會變成method本身
    window.onresize = function(){ // 定義視窗大小變化事件
        _this.screenWidth(window.innerWidth); //視窗寬度
    }
  }
}
</script>

<style>
@media (max-width: 991.98px) {
  .offcanvas-collapse {
    position: fixed;
    top: 91px; /* Height of navbar */
    bottom: 0;
    left: 100%;
    width: 70%;
    padding-right: 1rem;
    padding-left: 1rem;
    overflow-y: auto;
    visibility: hidden;
    background-color: #fff;
    transition-timing-function: ease-in-out;
    transition-duration: .3s;
    transition-property: left, visibility;
    box-shadow: -2px 10px 5px rgba(0, 0, 0, 0.1);
  }
  .offcanvas-height {
    top:54px !important;
    /* transform: translateY(54px) !important; */
  }
  .offcanvas-collapse.open {
    left: 60%;
    visibility: visible;
  }
  html,body {
    overflow-x: hidden; /* Prevent scroll on narrow devices */
  }
  .sm-menu{
    border: none;
  }
  .sm-menu a{
    color: #4c4c4c;
  }
  .sm-menu .dropdown-item{
    border-bottom: solid 1px #dedede;
    padding: .8rem 0 .5rem .3rem;
    
  }
  .navbar-light .navbar-nav .nav-link:hover::after { 
    position: absolute;
    content: '';
    height: 1.8px;  
    bottom: 10px;
    margin: 0 auto;
    left: 0;
    right: 50;
    width: 40%;
  }
  
    /* remove navbar button stying */
    .navbar-toggler {
        background: none;
        border: none;
      /* remove the blue outline when active or focused */
      /* basic styles for each icon bar */
      /* styles for when .navbar is closed */
    }
    .navbar-toggler:active, .navbar-toggler:focus {
        outline: 0;
    }
    .navbar-toggler .icon-bar {
        display: block;
        width: 22px;
        height: 2px;
        border-radius: 1px;
        margin: 4px 0 4px 0;
        transition: all 0.2s;
      /* custom .navbar-dark .icon-bar background */
      /* .navbar open top .icon-bar rotated down 45° */
      /* .navbar open middle .icon-bar invisible */
      /* .navbar open bottom .icon-bar rotated up 45° */
    }
    .navbar-light .navbar-toggler .icon-bar {
        background: #929292;
    }
    .navbar-toggler .icon-bar:nth-of-type(1) {
        transform: rotate(45deg);
        transform-origin: 10% 10%;
    }
    .navbar-toggler .icon-bar:nth-of-type(2) {
        opacity: 0;
        filter: alpha(opacity=0);
    }
    .navbar-toggler .icon-bar:nth-of-type(3) {
        transform: rotate(-45deg);
        transform-origin: 10% 90%;
    }
    /* .navbar-toggler.collapsed {
      /* .navbar closed top .icon-bar no rotation - straight 
    } */
    .navbar-toggler.collapsed .icon-bar {
        background-color: #929292;
      /* .navbar open middle .icon-bar visible */
      /* .navbar open bottom .icon-bar no rotation - straight */
    }
    .navbar-toggler.collapsed .icon-bar:nth-of-type(1) {
        transform: rotate(0);
    }
    .navbar-toggler.collapsed .icon-bar:nth-of-type(2) {
        opacity: 1;
        filter: alpha(opacity=100);
    }
    .navbar-toggler.collapsed .icon-bar:nth-of-type(3) {
        transform: rotate(0);
    }

}
body {
  padding-top: 90px;
}
#main-nav{
  top: 37px;
  padding: 0 5rem;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
  background: transparent linear-gradient(180deg, #FFFFFF 0%, #f1f1f1 100%) 0% 0% no-repeat padding-box;
}

.second-title{
  font-size: 1rem;
  letter-spacing: .2em;
  pointer-events: none;
  text-shadow: 0.1em 0.1em 0.2em rgba(100, 100, 100, 0.7);
}

.nav-logo {
    top: 0 !important ;
    transition: all .3s linear;
    /* transform: translateY(-78px) !important; */
  }
@media (max-width: 1280px) {
  #main-nav {
    padding: 0 3rem;
  }
  .second-title{
    font-size: .95rem;
  }
}

@media(max-width: 568px) {
  .offcanvas-collapse.open {
    left: 30%;
  }
}

@media(max-width: 492px) {
  body {
    padding-top: 90px;
  }
  #main-nav{
    top: 78px;
    padding: 0 1rem;
    transition: all .2s linear;
  }  
  .nav-en {
    top: 38px !important ;
  }
  .offcanvas-collapse {
    top: 132px; /* Height of navbar */ 
    z-index: 2;
  }  
  .nav-en .offcanvas-collapse {
    top: 91px;
  }
}
@media (max-width: 348px) {
  body {
    padding-top: 90px;
  }
  #main-nav{
    top: 78px;
    padding: .5em 1rem 0;
  }
  .offcanvas-collapse {
    top: 132px; 
  }
}

.dmenu:hover{
  background-color: #0087d7;
  /* background-color: #f0faff; */
}

.navbar-light .navbar-nav .nav-link:hover {
    color: #fff;
    /* color: #0186d7; */
    text-decoration: none; 
    position: relative; 
}
.navbar-light .navbar-nav .nav-link:hover::after {
      position: absolute;
      content: '';
      height: 1.8px;
    
      bottom: 10px;
      margin: 0 auto;
      left: 0;
      right: 0;
      width: 60%;
      background: #ffffff;

		  /* optional animation */
      -o-transition:.5s;
      -ms-transition:.5s;
      -moz-transition:.5s;
      -webkit-transition:.5s;
      transition:.5s;
}

.nav-scroller {
  position: relative;
  z-index: 2;
  height: 2.75rem;
  overflow-y: hidden;
}

.nav-scroller .nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding-bottom: 1rem;
  margin-top: -1px;
  overflow-x: auto;
  color: rgba(255, 255, 255, .75);
  text-align: center;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.nav-underline .nav-link {
  padding-top: .75rem;
  padding-bottom: .75rem;
  font-size: .875rem;
  color: #6c757d;
}

.nav-underline .nav-link:hover {
  color: #007bff;
}

.nav-underline .active {
  font-weight: 500;
  color: #343a40;
}
.mobile-nav .sm-menu{
  border: none;
}
.mobile-nav .dropdown-item{
  border-bottom: solid .5px #f1f1f1;
}
.text-white-50 { color: rgba(255, 255, 255, .5); }

.bg-purple { background-color: #6f42c1; }

.lh-100 { line-height: 1; }
.lh-125 { line-height: 1.25; }
.lh-150 { line-height: 1.5; }
</style>


// WEBPACK FOOTER //
// src/components/HeaderMenu.vue